import Post from './Post';
import { StreamWidgetBox } from './styled';
import EmptyState from './EmptyState';
import { StreamPostData } from '../../../@types/stream';

interface StreamWidgetProps {
  posts: StreamPostData[];
  isCompanyStock?: boolean;
}

/**
 * Stream Widget component
 * @param {string} props.symbol
 */
const GuestStream = ({
  posts = [],
  isCompanyStock = false,
}: StreamWidgetProps) => (
  <StreamWidgetBox
    noBorder={false}
    isCompanyStock={isCompanyStock}
    className="guest-stream"
  >
    {posts.length === 0 ? (
      <EmptyState description="" />
    ) : (
      posts.map((post) => <Post post={post} key={post.postid} hasFollowingActivity={false} entryPoint="stream" />)
    )}
  </StreamWidgetBox>
);

export default GuestStream;
